import { cleanPortalInternationalAndUSDid, isValidInternationalAndUSNumber } from '@nuso/common/util-did';
import { isGuid } from '@nuso/common/util-string';
import { MediaPointForm } from '@nuso/recording/types';
import {
  NusoSipSettings,
  PLATFORM_SERVICE_TYPES,
  PlatformServiceAbridged,
  TEAMS_SERVICE_TYPES,
} from '@nuso/services/types';

export function validateMediaPointFormData(mediaPointsToAdd: MediaPointForm[], service: PlatformServiceAbridged) {
  for (const mediaPoint of mediaPointsToAdd) {
    mediaPoint.device = mediaPoint.device?.trim();
    mediaPoint.name = mediaPoint.name?.trim();
    mediaPoint.appUserId = mediaPoint.appUserId?.trim();

    if (!mediaPoint.device) {
      return 'Device/Number is required.';
    }

    if (!mediaPoint.name) {
      return `Label is required for device/number ${mediaPoint.device}.`;
    }
  }

  if (mediaPointsToAdd.length != new Set(mediaPointsToAdd.map((t) => t.device)).size) {
    return 'Device/Number must be unique.';
  }

  if (TEAMS_SERVICE_TYPES.includes(service.type)) {
    const mediaPoint = mediaPointsToAdd.find((t) => !isGuid(t.device));
    if (mediaPoint) {
      return `Device/Number must be Teams user uuid: ${mediaPoint.device}.`;
    }

    if (mediaPointsToAdd.length != new Set(mediaPointsToAdd.map((t) => t.name)).size) {
      return 'Label must be unique for teams media points.';
    }
  }

  if (['cloud-uc', 'nuso-sip'].includes(service.type)) {
    for (const mediaPoint of mediaPointsToAdd) {
      const did = cleanPortalInternationalAndUSDid(mediaPoint.device);
      if (!isValidInternationalAndUSNumber(did)) {
        return `Device/Number must be a valid number: ${mediaPoint.device}.`;
      }

      mediaPoint.device = did;
    }
  }

  return null;
}

export function resolveMediaPointType(service: PlatformServiceAbridged & { settings: any }, mediaPoint: string) {
  const { CLOUD_UC, NUSO_SIP, GREEN_UC } = PLATFORM_SERVICE_TYPES;

  // cloud-uc
  if (service.type === CLOUD_UC.name && isGuid(mediaPoint)) return 'USER';
  
  // green-uc
  if (service.type === GREEN_UC.name) return 'USER';

  // nuso-sip
  const sipSettings = service.settings.serviceSettings as NusoSipSettings;
  if (service.type === NUSO_SIP.name && sipSettings.pbxNumber === mediaPoint) return 'TRUNK';

  // teams
  if (TEAMS_SERVICE_TYPES.includes(service.type)) return 'TEAMS';

  // default
  return 'DID';
}
